var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.s.number, _vm.numberClassName]},[_vm._v(" "+_vm._s(_vm.prefix)+_vm._s(_vm.symbol)+_vm._s(_vm.int)),_c('span',{class:[_vm.s.fraction, _vm.fractionClassName]},[_vm._v(_vm._s(_vm.fraction))])])
}
var staticRenderFns = []

export { render, staticRenderFns }